<template>
    <div 
        class="header d-flex align-center justify-center"
        :class="`header-${ !!$mq.phone ? 'sm' : !!$mq.tablet ? 'md' : 'lg' }`"
    >
        <div class="header-content align-self-stretch flex-fill d-flex flex-column align-center justify-center semi-gray">
            <img 
                class="header-logo" 
                :alt="org" 
                :src="logo"
            >
            
            <span class="display-1 mt-5 mx-10 px-10 custom-white-text">{{ slogan }}</span>
        </div>
    </div>
</template>

<script>
import VideoBg from 'vue-videobg'

export default {
    name: "Header",
    components: {
        VideoBg,
    },
    computed: {
        logo() {
            return require(`../assets/img/logo-${ this.light ? 'light' : 'dark' }-${ !!this.$mq.phone ? 'sm' : !!this.$mq.tablet ? 'md' : 'lg' }.png`)
        }
    },
    data() {
        return {
            light: true,
            org: process.env.VUE_APP_ORG,
            slogan: process.env.VUE_APP_ORG_SLOGAN,
        }
    },
    methods: {},
}
</script>

<style>
.header {
    position: relative;
    height: 80vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
}

.header.header-sm {
    background-image: url(../assets/img/header-sm.jpg);
    background-attachment: scroll !important;
}

.header.header-md {
  background-image: url(../assets/img/header-md.jpg);
}

.header.header-lg {
  background-image: url(../assets/img/header-lg.jpg);
}  

.header-logo {
  width: 25vw;
  min-width: 250px;
  max-width: 550px;
  height: auto;
}
</style>
